/*
 *  Kode for validering av organisasjonsnummer
 *
 *  updated 08 Feb 2021
 *  by Lars Erik Storbukås <https://github.com/storbukas>
 *
 *  Source: https://github.com/storbukas/norsk-validator
 *
 *  Licensed under the MIT License
 *  https://opensource.org/licenses/MIT
 *
 */
'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var kontrollsiffer_1 = require("./tools/kontrollsiffer");
var organisasjonsnummer = function (organisasjonsnummer) {
    var organisasjonsnummerString = organisasjonsnummer.toString();
    if (!organisasjonsnummerString || organisasjonsnummerString.length !== 9) {
        return false;
    }
    return parseInt(organisasjonsnummerString.charAt(organisasjonsnummerString.length - 1), 10)
        === kontrollsiffer_1.kontrollsiffferMod11(organisasjonsnummerString);
};
exports.default = organisasjonsnummer;
